import { addDays, dstr, fmtDM, fmtH, fromD, loc, money, startOfWeek, today } from '../dates.js';
import { t } from '../i18n/index.js';
import { eventsIn, plannedAmount, statsRange } from '../model.js';
import { S } from '../state.js';
import { IC, esc } from '../ui.js';
import { CLOUD } from '../cloud/api.js';

export function svgBars(items,fmt,color){
  const W=560,H=170,pad=6,max=Math.max(...items.map(i=>i.v),1);
  const bw=(W-pad*2)/items.length;
  let s='<svg viewBox="0 0 '+W+' '+(H+26)+'">';
  items.forEach((it,i)=>{
    const h=Math.max(2,it.v/max*(H-14));const x=pad+i*bw;
    s+='<rect x="'+(x+3)+'" y="'+(H-h)+'" width="'+(bw-6)+'" height="'+h+'" rx="5" fill="'+(color||'var(--bleu)')+'" opacity="'+(it.v?'.92':'.18')+'"><title>'+esc(it.l)+': '+esc(fmt(it.v))+'</title></rect>';
    if(i%Math.ceil(items.length/6)===0)s+='<text x="'+(x+bw/2)+'" y="'+(H+17)+'" text-anchor="middle" font-size="10" fill="var(--ink3)">'+esc(it.l)+'</text>';
  });
  return s+'</svg>';
}
export function svgDonut(parts){
  const R=54,C=2*Math.PI*R;let off=0;
  const total=parts.reduce((a,p)=>a+p.v,0)||1;
  let s='<svg viewBox="0 0 160 160" style="max-width:190px;margin:0 auto"><g transform="rotate(-90 80 80)">';
  for(const p of parts){
    const frac=p.v/total;
    s+='<circle cx="80" cy="80" r="'+R+'" fill="none" stroke="'+p.c+'" stroke-width="20" stroke-dasharray="'+(frac*C-2)+' '+(C-frac*C+2)+'" stroke-dashoffset="'+(-off*C)+'"><title>'+esc(p.l)+' '+Math.round(frac*100)+'%</title></circle>';
    off+=frac;
  }
  return s+'</g><text x="80" y="86" text-anchor="middle" font-size="17" font-weight="700" fill="var(--ink)" font-family="Bricolage">'+esc(parts.total||'')+'</text></svg>';
}
export function vStats(){
  const M=!(CLOUD.ctx&&CLOUD.ctx.role==='tutor');   // teachers in a school: hours, no money
  // hours per week (12)
  const wk=[];const w0=startOfWeek(today());
  for(let i=11;i>=0;i--){const f=addDays(w0,-7*i);wk.push({l:fmtDM(f),v:+(statsRange(f,addDays(f,6)).mins/60).toFixed(1)})}
  // earnings per month (12)
  const mo=[];const now=fromD(today());
  for(let i=11;i>=0;i--){const d=new Date(now.getFullYear(),now.getMonth()-i,1);const f=dstr(d);const to=dstr(new Date(d.getFullYear(),d.getMonth()+1,0));
    mo.push({l:d.toLocaleDateString(loc(),{month:'short'}),v:+statsRange(f,to).amt.toFixed(0)})}
  // by student this year
  const y0=today().slice(0,4)+'-01-01';
  const byS=S.students.map(s=>({l:s.first,c:s.color,v:S.sessions.filter(x=>x.studentId===s.id&&x.status==='done'&&x.date>=y0).reduce((a,x)=>a+ +x.dur,0)/60})).filter(x=>x.v>0).sort((a,b)=>b.v-a.v);
  const done=S.sessions.filter(s=>s.date<=today()&&s.status!=='planned');
  const dn=done.filter(s=>s.status==='done').length,ns=done.filter(s=>s.status==='noshow').length,cc=done.filter(s=>s.status==='cancelled').length;
  const tot=done.length||1;
  const yr=statsRange(y0,today());const all=statsRange('2000-01-01',today());
  const upcoming=eventsIn(today(),addDays(today(),30)).filter(e=>e.status==='planned').reduce((a,e)=>a+plannedAmount(e),0);
  const avgW=(wk.reduce((a,x)=>a+x.v,0)/12).toLocaleString(loc(),{minimumFractionDigits:1,maximumFractionDigits:1});
  const donutParts=byS.slice(0,8);donutParts.total=byS.reduce((a,x)=>a+x.v,0).toFixed(0)+'h';
  return `<div class="viewhead"><div><div class="eyebrow">${t('nav.stats')}</div><h1>${t('stats.title')}</h1></div>
  <div class="headactions"><button class="btn small" data-a="csvS">${IC.dl} ${t('stats.csvS')}</button>${M?`<button class="btn small" data-a="csvI">${IC.dl} ${t('stats.csvI')}</button>`:''}</div></div>
  <div class="statgrid">
    <div class="stat"><div class="v">${fmtH(yr.mins)}</div><div class="l">${t('stats.year')}</div><div class="d">${M?money(yr.amt)+' · ':''}${yr.count} ${t('stats.sessions')}</div></div>
    <div class="stat"><div class="v">${fmtH(all.mins)}</div><div class="l">${t('stats.all')}</div><div class="d">${M?money(all.amt):''}</div></div>
    <div class="stat accent"><div class="v">${avgW} ${t('c.h')}</div><div class="l">${t('stats.avg')}</div></div>
    ${M?`<div class="stat"><div class="v">${money(upcoming)}</div><div class="l">${t('stats.projected')}</div><div class="d">${t('stats.projHint')}</div></div>`:''}
  </div>
  <div class="grid2">
    <div class="card"><div class="cardhead"><h2>${t('stats.hpw')}</h2><span class="tiny">${t('stats.range12w')}</span></div><div class="chartwrap">${svgBars(wk,v=>v+' h')}</div></div>
    ${M?`<div class="card"><div class="cardhead"><h2>${t('stats.epm')}</h2><span class="tiny">${t('stats.range12m')}</span></div><div class="chartwrap">${svgBars(mo,v=>money(v),'var(--marge)')}</div></div>`:''}
  </div>
  <div class="grid2 mt">
    <div class="card"><div class="cardhead"><h2>${t('stats.byStu')}</h2><span class="tiny">${t('stats.year')}</span></div>
      ${byS.length?'<div class="chartwrap">'+svgDonut(donutParts)+'</div><div class="legend">'+byS.slice(0,8).map(x=>'<span class="li"><span class="dot" style="background:'+x.c+'"></span>'+esc(x.l)+' — '+x.v.toFixed(1)+'h</span>').join('')+'</div>':'<div class="empty"><p>—</p></div>'}
    </div>
    <div class="card"><div class="cardhead"><h2>${t('stats.sessions')}</h2></div>
      <div class="listrow"><div class="grow">${t('stats.completion')}</div><b style="font-variant-numeric:tabular-nums">${Math.round(dn/tot*100)}%</b></div>
      <div class="listrow"><div class="grow">${t('stats.cancelled')}</div><b style="font-variant-numeric:tabular-nums">${Math.round(cc/tot*100)}%</b></div>
      <div class="listrow"><div class="grow">${t('stats.noshow')}</div><b style="font-variant-numeric:tabular-nums">${Math.round(ns/tot*100)}%</b></div>
    </div>
  </div>`;
}

/* ================= SETTINGS ================= */
